module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-wrap kiwi-wrap-error"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('error_starting')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('error_installed')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb55fc54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartupError.vue
// module id = 506
// module chunks = 2